import type { ReactNode } from "react";

export function MenuItemIconWrapper({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      style={{ width: 16, height: 16, display: "flex", alignItems: "center", justifyContent: "center" }}
      className={className}
    >
      {children}
    </div>
  );
}
